import React from "react";
import LoginForm from "./components/LoginForm";
import { LoginDiv } from "./Login.style";
import CoverPage from "../coverPage";
import Cookies from "js-cookie";

function Login() {  

  const webView = Cookies.get('webView');  

  return (
    <LoginDiv webView={webView}>
      <CoverPage/>
      <div className="login__right">
        <LoginForm />
      </div>
    </LoginDiv>
  );
}

export default Login;
